export default __webpack_public_path__ + "static/media/480_business06-nl-web.228516f5.png";